const name = 'typist';
const path = '/digitadores';

export default [
  // routes
  {
    name,
    path,
    component: () => import('@/views/TypistList.vue'),
    props: true,
  },
  {
    name: `${name}-edit`,
    path: `${path}/:id`,
    component: () => import('@/views/TypistEdit.vue'),
    props: true,
  },

  // redirects
  {
    path: '/usuarios/digitadores/:id',
    redirect: `${path}/:id`,
  },
];
